import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import Form from "react-bootstrap/Form";
// import { Broker } from "./interface";
// import "../../Components/SharedComponents/InputBox.scss";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  type MRT_TableOptions,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { toast } from "react-toastify";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import { CompactTextField } from "../../Components/SharedComponents/SharedComponents";
import FileUpload from "../../Components/FileUpload/FileUpload";
import BrokerTemplateDownloadButton from "../../Components/TemplateDownloadButton/BrokerTemplateDownloadButton";
import { TableColumnVisibilityMenu } from "../../Components/SharedComponents/TableColumnVisibilityMenu";
import { CommonToolbarInternalActions } from "../../Components/SharedComponents/CommonTableToolbarActions";
import { MRT_COLUMN_FILTERS_COUNTERPARTY_COMPANIES, MRT_COLUMN_VISIBILITY_COUNTERPARTY_COMPANIES, MRT_DENSITY_COUNTERPARTY_COMPANIES, MRT_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES, MRT_SHOW_COLUMN_FILTERS_COUNTERPARTY_COMPANIES, MRT_SHOW_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES, MRT_SORTING_COUNTERPARTY_COMPANIES } from "../../Constants/TableFilter.constants";
type counterPartyType = {
  id: string;
  customer_company_name: string;
  email: string;
  account?: number;
  credit_limit?: number;
  im_buffer_factor?: number;
  remarks: string;
};

interface User {
  id: string;
  customer_company_name: string;
  email: string;
  account: string;
  credit_limit: string;
  im_buffer_factor: string;
  remarks: string;
}
type OptionType = { id: string; name: string };
// Add these interfaces at the top of your file
// Form data interface
// Form data interface
interface FormData {
  customer_company_name: string;
  email: string;
  account: string;
  credit_limit: string;
  im_buffer_factor: string;
  remarks: string;
}

const Example = () => {
  const [formData, setFormData] = useState<FormData>({
    customer_company_name: "",
    email: "",
    account: "",
    credit_limit: "",
    im_buffer_factor: "",
    remarks: "",
  });
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [formErrors, setFormErrors] = useState<Partial<FormData>>({});
  const [touched, setTouched] = useState<
    Partial<Record<keyof FormData, boolean>>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [CounterpartyName, setBrokerName] = useState<string>("");
  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15, //set different default page size by initializing the state here
  });

  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);

  // const [customerCompanyName, setCustomerCompanyName] = useState<string>("");
  // const [email, setEmail] = useState<string>("");
  // const [account, setAccount] = useState<number | undefined>(undefined);
  // const [creditLimit, setCreditLimit] = useState<number | undefined>(undefined);
  // const [remarks, setRemarks] = useState<string>("");

  const [counterPartyData, setCounterPartyData] = useState<User[]>([]);

  const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
  const handleFileUploadOpen = () => setOpenFileUpload(true);
  const handleFileUploadClose = () => setOpenFileUpload(false);

  const handleFileUploadSubmit = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/derivatives/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      queryClient.invalidateQueries({ queryKey: ["users"] });

      return {
        success: true,
        message: "File uploaded and data added successfully!",
        data: response.data,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to upload file",
      };
    }
  };
  // Validate individual field
  // Validate individual field
  // Validate individual field
  const validateField = (field: keyof FormData, value: string) => {
    let error = "";

    // IM Factor is optional
    if (field === "im_buffer_factor") {
      error = "";
    }
    // Handle numeric fields differently
    else if (field === "account" || field === "credit_limit") {
      if (value === "") {
        error = `${field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
      }
    }
    // Handle string fields
    else {
      if (field !== "remarks" && !value.trim()) {
        error = `${field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
      } else if (field === "email" && !validateEmail(value)) {
        error = "Incorrect Email Format";
      }
    }

    setFormErrors((prev) => ({ ...prev, [field]: error }));
    return error;
  };

  // Validate entire form
  // Validate entire form
  const validateFormData = () => {
    const newErrors: Partial<FormData> = {};
    const requiredFields: (keyof FormData)[] = [
      "customer_company_name",
      "email",
      "account",
      "credit_limit",
    ];

    requiredFields.forEach((field) => {
      // Handle numeric fields differently
      if (field === "account" || field === "credit_limit") {
        if (formData[field] === "") {
          newErrors[field] = `${field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
        }
      }
      // Handle string fields
      else {
        if (!formData[field].trim()) {
          newErrors[field] = `${field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
        } else if (field === "email" && !validateEmail(formData[field])) {
          newErrors[field] = "Incorrect Email Format";
        }
      }
    });

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Update form data
  // Update form data
  const updateFormData = (field: keyof FormData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setTouched((prev) => ({ ...prev, [field]: true }));

    // Clear error if the field is valid (remarks and IM factor are optional)
    if (
      field === "remarks" ||
      field === "im_buffer_factor" ||
      (value.trim() && (field !== "email" || validateEmail(value)))
    ) {
      setFormErrors((prev) => ({ ...prev, [field]: undefined }));
    } else {
      validateField(field, value);
    }
  };

  // Handle blur event
  const handleBlur = (field: keyof FormData, value: string): string | null => {
    const error = validateField(field, value);
    return error || null;
  };

  // Validate entire form
  // const validateFormData = () => {
  //   const newErrors: Partial<FormData> = {};
  //   Object.keys(formData).forEach((key) => {
  //     const field = key as keyof FormData;
  //     if (!formData[field].trim()) {
  //       newErrors[field] = `${field
  //         .replace(/_/g, " ")
  //         .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
  //     } else if (field === "email" && !validateEmail(formData[field])) {
  //       newErrors[field] = "Incorrect Email Format";
  //     }
  //   });
  //   setFormErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // Update form data
  // const updateFormData = (field: keyof FormData, value: string) => {
  //   setFormData((prev) => ({ ...prev, [field]: value }));
  //   setTouched((prev) => ({ ...prev, [field]: true }));
  //   // Clear error if the field is valid
  //   if (value.trim() && (field !== "email" || validateEmail(value))) {
  //     setFormErrors((prev) => ({ ...prev, [field]: undefined }));
  //   } else {
  //     validateField(field, value);
  //   }
  // };

  // Handle focus to mark field as touched
  const handleFocus = (field: keyof FormData) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };
  useEffect(() => {
    //do something when the pagination state changes
  }, [pagination]);

  useEffect(() => {
    sessionStorage.clear();
    const columnFilters = sessionStorage.getItem(MRT_COLUMN_FILTERS_COUNTERPARTY_COMPANIES);
    const columnVisibility = sessionStorage.getItem(
      MRT_COLUMN_VISIBILITY_COUNTERPARTY_COMPANIES
    );
    const density = sessionStorage.getItem(MRT_DENSITY_COUNTERPARTY_COMPANIES);
    const globalFilter = sessionStorage.getItem(MRT_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES);
    const showGlobalFilter = sessionStorage.getItem(
      MRT_SHOW_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES
    );
    const showColumnFilters = sessionStorage.getItem(
      MRT_SHOW_COLUMN_FILTERS_COUNTERPARTY_COMPANIES
    );
    const sorting = sessionStorage.getItem(MRT_SORTING_COUNTERPARTY_COMPANIES);

    if (columnFilters) {
      setColumnFilters(JSON.parse(columnFilters));
    }
    if (columnVisibility) {
      setColumnVisibility(JSON.parse(columnVisibility));
    }
    if (density) {
      setDensity(JSON.parse(density));
    }
    if (globalFilter) {
      setGlobalFilter(JSON.parse(globalFilter) || undefined);
    }
    if (showGlobalFilter) {
      setShowGlobalFilter(JSON.parse(showGlobalFilter));
    }
    if (showColumnFilters) {
      setShowColumnFilters(JSON.parse(showColumnFilters));
    }
    if (sorting) {
      setSorting(JSON.parse(sorting));
    }
    isFirstRender.current = false;
  }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_COUNTERPARTY_COMPANIES,
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);
  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_COUNTERPARTY_COMPANIES,
      JSON.stringify(columnFilters)
    );

    console.log("columnFilters", "columnFilters---------------", columnFilters);
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_VISIBILITY_COUNTERPARTY_COMPANIES,
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_DENSITY_COUNTERPARTY_COMPANIES, JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES,
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_GLOBAL_FILTERS_COUNTERPARTY_COMPANIES,
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_COLUMN_FILTERS_COUNTERPARTY_COMPANIES,
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_SORTING_COUNTERPARTY_COMPANIES, JSON.stringify(sorting));
  }, [sorting]);

  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      // {
      //   accessorKey: "id",
      //   header: "Id",
      //   enableEditing: false,
      //   enableSorting: false,
      //   Cell: ({ row }) => row.index + 1,

      // },
      {
        accessorKey: "customer_company_name",
        header: "Customer Company",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.customerCompany,
          helperText: validationErrors?.customerCompany,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              customerCompany: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },

      {
        accessorKey: "account",
        header: "Customer Account",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.account,
          helperText: validationErrors?.account,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              account: undefined,
            }),
        },
      },
      {
        accessorKey: "credit_limit",
        header: "Credit Limit",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.creditLimit,
          helperText: validationErrors?.creditLimit,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              creditLimit: undefined,
            }),
        },
      },
      {
        accessorKey: "im_buffer_factor",
        header: "IM Factor",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          type: "number",
          error: !!validationErrors?.im_buffer_factor,
          helperText: validationErrors?.im_buffer_factor,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              im_buffer_factor: undefined,
            }),
        },
      },
      {
        accessorKey: "email",
        header: "Email",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.email,
          helperText: validationErrors?.email,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              email: undefined,
            }),
        },
      },

      {
        accessorKey: "remarks",
        header: "Remarks",
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },

      // {
      //   accessorKey: "state",
      //   header: "State",

      //   filterVariant: "multi-select",
      //   filterSelectOptions: usStateList,
      //   editVariant: "select",
      //   editSelectOptions: usStates,

      //   muiEditTextFieldProps: {
      //     select: true,
      //     error: !!validationErrors?.state,
      //     helperText: validationErrors?.state,
      //   },
      // },
    ],
    [validationErrors]
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(filterModes, pagination, setTotalCount, sorting);
  //call UPDATE hook

  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  // CREATE FUNCTION TO ADD NEW A BROKER
  // CREATE FUNCTION TO ADD NEW A BROKER
  const createBroker = async (counterparty: {
    name: string;
    account?: number;
    credit_limit?: number;
    im_buffer_factor?: number;
    email: string;
    remarks: string;
  }) => {
    if (!counterparty.name) {
      toast.error("Counterparty name is required!");
      return;
    }

    try {
      const payload = {
        customer_company_name: counterparty.name,
        account: counterparty.account,
        credit_limit: counterparty.credit_limit,
        im_buffer_factor: counterparty.im_buffer_factor ?? null,
        email: counterparty.email,
        remarks: counterparty.remarks || "", // Send empty string instead of null
      };

      await axiosInstance.post(
        `${backendbaseUrl}/paper-app/counterparty-companies/`,
        payload
      );

      queryClient.invalidateQueries({ queryKey: ["users"] });
      return true; // Return success status
    } catch (error: any) {
      console.error("Error adding Counterparty:", error);
      if (
        error.response?.status === 400 &&
        error.response?.data?.detail?.includes("already exists")
      ) {
        toast.error("A counterparty with this company name already exists!");
      } else {
        toast.error("Failed to add Counterparty. Please try again.");
      }
      return false; // Return failure status
    }
  };
  // create by submitting the form
  // Create by submitting the form
  const formCreate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTouched({
      customer_company_name: true,
      email: true,
      account: true,
      credit_limit: true,
      remarks: true,
    });
    if (!validateFormData()) {
      return;
    }

    try {
      const success = await createBroker({
        name: formData.customer_company_name,
        account: formData.account ? Number(formData.account) : undefined,
        credit_limit: formData.credit_limit
          ? Number(formData.credit_limit)
          : undefined,
        im_buffer_factor: formData.im_buffer_factor
          ? Number(formData.im_buffer_factor)
          : undefined,
        email: formData.email,
        remarks: formData.remarks,
      });
      if (success) {
        setFormData({
          customer_company_name: "",
          email: "",
          account: "",
          credit_limit: "",
          im_buffer_factor: "",
          remarks: "",
        });
        setFormErrors({});
        setTouched({});
        toast.success("Counterparty added successfully!");
      }
    } catch (error: any) {
      console.error("Error creating counterparty:", error);
      // toast.error("Failed to add Counterparty. Please try again.");
      let errorMessage = "Failed to add Counterparty. Please try again.";

      // Handle the specific error structure
      if (error.response?.data?.error) {
        const errorString = error.response.data.error;

        // Extract message from string format like "{'non_field_errors': [ErrorDetail(string='...', code='invalid')]}"
        const match = errorString.match(/string='([^']+)'/);
        if (match && match[1]) {
          errorMessage = match[1];
        } else {
          errorMessage = errorString;
        }
      } else if (error.response?.data?.non_field_errors?.length > 0) {
        // Handle proper JSON structure (your original code)
        const firstError = error.response.data.non_field_errors[0];
        if (firstError.string) {
          errorMessage = firstError.string;
        }
      } else if (error.response?.data?.detail?.string) {
        errorMessage = error.response.data.detail.string;
      } else if (error.response?.data?.detail) {
        errorMessage =
          typeof error.response.data.detail === "string"
            ? error.response.data.detail
            : errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      // Reset form fields regardless of success or error
      setFormData({
        customer_company_name: "",
        email: "",
        account: "",
        credit_limit: "",
        im_buffer_factor: "",
        remarks: "",
      });
      setFormErrors({});
      setTouched({});
    }
  };

  // CREATE action
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error !== "")) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    await createUser(values);
    table.setCreatingRow(null);
  };

  // UPDATE action
  const handleeditsave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    const updatedUser = { ...row.original, ...values };
    const newValidationErrors = validateUser(updatedUser);
    if (Object.values(newValidationErrors).some((error) => error !== "")) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    try {
      await updateUser(updatedUser);
      toast.success("Counterparty updated successfully!");
      table.setEditingRow(null);
    } catch (error) {
      console.error("User Update Error:", error);
      toast.error("Failed to update counterparty. Please try again.");
    }
  };

  // DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this Counterparty?",
      content: "Deleting...",
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("User deleted successfully!");
          })
          .catch((error) => {
            toast.error("Failed to delete user. Please try again.");
          });
      },
    });
  };

  // COPY ROW action
  const handleCopyRow = (row: MRT_Row<User>) => {
    try {
      if (!row?.original) {
        toast.error("No row data to copy");
        return;
      }

      const {
        customer_company_name = "",
        email = "",
        account = "",
        credit_limit = "",
        im_buffer_factor,
        remarks = "",
      } = row.original;

      // Update formData
      setFormData({
        customer_company_name,
        email,
        account,
        credit_limit,
        im_buffer_factor:
          im_buffer_factor === null || im_buffer_factor === undefined
            ? ""
            : String(im_buffer_factor),
        remarks,
      });

      // Visual feedback
      window.scrollTo({ top: 0, behavior: "smooth" });
      toast.success("Counterparty Row data copied to form");

      // Highlight effect
      setInputBackgroundColour("#83bf6e26");
      const highlightTimeout = setTimeout(() => {
        setInputBackgroundColour("");
        clearTimeout(highlightTimeout);
      }, 2400);
    } catch (error) {
      console.error("Error copying Counterparty data:", error);
      toast.error("Failed to copy Counterparty data");
    }
  };

  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  // Function to handle right-click and open the menu
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  // Function to handle menu close
  const handleClose = () => {
    setContextMenu(null);
  };

  // Function to handle Paste action
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setBrokerName(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success("copied and pasted successfully");
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour(""); // Then set it again
        }, 2400);
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        jsonData = { rawText: text }; // Fallback if not valid JSON
      }

      // Here, you can use jsonData further as needed
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
    }

    handleClose();
  };

  // Function to handle Mark action
  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

  const handleExportRows = (rows: MRT_Row<any>[]) => {
    const rowData = rows.map((row) => row.original);
    console.log(rowData);
  };

  const handleDataDownload = async () => {
    try {
      const response = await axiosInstance.get(
        `${backendbaseUrl}/paper-app/counterparty-companies/export-delete`,
        {
          responseType: "blob",
          headers: {
            // Add any required headers
            "Content-Type": "application/json",
          },
        }
      );

      // Check if response is valid
      if (!response.data) {
        throw new Error("No data received from server");
      }

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "all_counterparty_companies.csv");
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success("All data download started");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download all data");
    }
  };
  const handleBulkDelete = async (rows: MRT_Row<any>[]) => {
    // 1. Get selected row IDs
    const rowIds = rows.map((row) => row.original.id);

    if (rowIds.length === 0) {
      toast.warn("Please select at least one Counterparty to delete.");
      return;
    }

    // 2. Debug: Verify selected IDs before sending
    console.log("Selected IDs for deletion:", rowIds);

    try {
      // 3. Show confirmation dialog
      showDeleteConfirmModal({
        title: `Delete ${rowIds.length} selected Counterparty(s)?`,
        content: `This will permanently delete ${rowIds.length} Counterparty(s). Continue?`,
        onOk: async () => {
          const loadingToast = toast.loading(
            `Deleting ${rowIds.length} Counterparty(s)...`
          );
          const payload = {
            ids: rowIds.filter((id) => id), // Ensure no empty/null IDs
          };
          console.log(payload);
          try {
            // 4. Prepare exact payload format API expects
            const payload = {
              ids: rowIds.filter((id) => id), // Ensure no empty/null IDs
            };

            // 5. Debug: Verify final payload
            console.log("Sending delete payload:", payload);

            // 6. Make API call
            const response = await axiosInstance.delete(
              `${backendbaseUrl}/paper-app/counterparty-companies/export-delete/`,
              {
                data: payload,
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              }
            );

            // 7. Handle response
            if (response.status === 200) {
              toast.success(
                `Successfully deleted ${rowIds.length} Counterparty(s)`
              );

              // 8. Refresh data and clear selection
              queryClient.invalidateQueries({ queryKey: ["users"] });
              table.setRowSelection({});
            } else {
              throw new Error(response.data?.message || "Unknown error occurred");
            }
          } catch (error: any) {
            // 9. Enhanced error handling
            console.error("Delete error details:", {
              message: error.message,
              response: error.response?.data,
              status: error.response?.status,
            });

            const errorMessage =
              error.response?.data?.detail ||
              error.response?.data?.message ||
              error.message ||
              "Failed to delete Counterpartys";

            toast.error(`Deletion failed: ${errorMessage}`);
          } finally {
            toast.dismiss(loadingToast);
          }
        },
      });
    } catch (error) {
      console.error("Confirmation dialog error:", error);
      toast.error("An error occurred during the deletion process.");
    }
  };
  const table = useMaterialReactTable({
    columns,

    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    // enableRowNumbers: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: false,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    // positionToolbarAlertBanner: "bottom",
    // layoutMode: "semantic",
    // enableColumnResizing: showRowResizing,
    enableColumnResizing: true,
    // columnResizeMode: "onEnd",
    // defaultColumn: {
    //   minSize: 50,
    //   enableResizing: true,
    // },
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: true,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    muiTopToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    }),
    muiTableContainerProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-container-wrapper__new",
    }),
    muiTableFooterProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-footer-wrapper__new",
    }),
    muiBottomToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
      },
      className: "bottom-toolbar-wrapper__new",
    }),
    muiTableBodyRowProps: ({ row, table }) => ({
      onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event.key === "Enter") {
          event.preventDefault();

          const editingRow = table.getState().editingRow;
          if (editingRow) {
            const saveHandler = table.options.onEditingRowSave;
            if (saveHandler) {
              const newedit = {
                ...editingRow.original,
                ...editingRow._valuesCache,
              };
              console.log("Saving:", newedit);

              saveHandler({
                exitEditingMode: () => table.setEditingRow(null),
                row: editingRow,
                table,
                values: newedit,
              });
            }
          }
        }
      },
    }),

    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    // initialState: { showColumnFilters: true }, //show filters by default
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },

    // defaultDisplayColumn: {
    //   enableResizing: true, //turn on some features that are usually off for all display columns
    // },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        size: 120, //set custom width
        muiTableHeadCellProps: {
          // align: "center", //change head cell props
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true, //turn on some features that are usually off
        // enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        // size: 50,
      },
    },
    renderToolbarInternalActions: (props) => <CommonToolbarInternalActions {...props} />,
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        className="table-download__wrapper"
        sx={{
          display: "flex",
          gap: "6px",
          padding: "0px",
          flexWrap: "wrap",
        }}
      >
        <Button startIcon={<UploadFileIcon />} onClick={handleFileUploadOpen}>
          Upload File
        </Button>
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => handleDataDownload()}
          startIcon={<BrowserUpdatedIcon />}
        >
          Export All Data
        </Button>
        {/* <BrokerTemplateDownloadButton
                  apiEndpoint="/paper-app/download-strategy-template/"
                  buttonText="Download Template"
                  fileName="strategy_template.csv"
                /> */}
        {/* <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)

          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)

          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            style={{ color: "red" }}
            onClick={() => handleBulkDelete(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
          >
            Delete Selected ({table.getSelectedRowModel().rows.length})
          </Button>
        )}
      </Box>
    ),

    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: "error",
          children: "Error loading data",
        }
      : undefined,

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleeditsave,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            {" "}
            {/* ✅ Pass row as argument */}
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: true,
    },
  });

  const transformedFilters = columnFilters.map((filter) => ({
    ...filter,
    mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
  }));

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));

    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  const someEventHandler = (event: any) => {
    console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
    console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
    console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
  };
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Add New Counterparty
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form onSubmit={formCreate}>
                      <div className="form_contain">
                        <div
                          className={`flex formWrapper ${
                            inputBackgroundColour !== "" ? "inputboxcustom" : ""
                          }`}
                          style={{ backgroundColor: inputBackgroundColour }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              p: { xs: 1, sm: 1 },
                              pt: "20px !important",
                              backgroundColor: "#ffff",
                              borderRadius: "4px",
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <Box
                              className="form_default"
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                justifyContent: "start",
                                gap: 0.5,
                                "& > *": {
                                  minWidth: {
                                    xs: "100%",
                                    sm: "48%",
                                    md: "23%",
                                    lg: "15%",
                                    xl: "7.5%",
                                  },
                                },
                              }}
                            >
                              <CompactTextField
                                label="Customer Company"
                                value={formData.customer_company_name}
                                onChange={(value) =>
                                  updateFormData("customer_company_name", value)
                                }
                                name="customer_company_name"
                                error={Boolean(
                                  formErrors.customer_company_name &&
                                    touched.customer_company_name
                                )}
                                helperText={
                                  formErrors.customer_company_name &&
                                  touched.customer_company_name
                                    ? formErrors.customer_company_name
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("customer_company_name", value)
                                }
                                onFocus={() =>
                                  handleFocus("customer_company_name")
                                }
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <CompactTextField
                                label="Customer Account"
                                type="number"
                                value={formData.account}
                                onChange={(value) =>
                                  updateFormData("account", value)
                                }
                                name="account"
                                error={Boolean(
                                  formErrors.account && touched.account
                                )}
                                helperText={
                                  formErrors.account && touched.account
                                    ? formErrors.account
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("account", value)
                                }
                                onFocus={() => handleFocus("account")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <CompactTextField
                                label="Credit Limit"
                                value={formData.credit_limit}
                                onChange={(value) =>
                                  updateFormData("credit_limit", value)
                                }
                                name="credit_limit"
                                type="number"
                                error={Boolean(
                                  formErrors.credit_limit &&
                                    touched.credit_limit
                                )}
                                helperText={
                                  formErrors.credit_limit &&
                                  touched.credit_limit
                                    ? formErrors.credit_limit
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("credit_limit", value)
                                }
                                onFocus={() => handleFocus("credit_limit")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <CompactTextField
                                label="IM Factor"
                                value={formData.im_buffer_factor}
                                onChange={(value) =>
                                  updateFormData("im_buffer_factor", value)
                                }
                                name="im_buffer_factor"
                                type="number"
                                error={Boolean(
                                  formErrors.im_buffer_factor &&
                                    touched.im_buffer_factor
                                )}
                                helperText={
                                  formErrors.im_buffer_factor &&
                                  touched.im_buffer_factor
                                    ? formErrors.im_buffer_factor
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("im_buffer_factor", value)
                                }
                                onFocus={() => handleFocus("im_buffer_factor")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <CompactTextField
                                label="Email"
                                value={formData.email}
                                onChange={(value) =>
                                  updateFormData("email", value)
                                }
                                name="email"
                                error={Boolean(
                                  formErrors.email && touched.email
                                )}
                                helperText={
                                  formErrors.email && touched.email
                                    ? formErrors.email
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("email", value)
                                }
                                onFocus={() => handleFocus("email")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <CompactTextField
                                label="Remarks"
                                value={formData.remarks}
                                onChange={(value) =>
                                  updateFormData("remarks", value)
                                }
                                name="remarks"
                                error={Boolean(
                                  formErrors.remarks && touched.remarks
                                )}
                                helperText={
                                  formErrors.remarks && touched.remarks
                                    ? formErrors.remarks
                                    : ""
                                }
                                validateOnBlur={(value) =>
                                  handleBlur("remarks", value)
                                }
                                onFocus={() => handleFocus("remarks")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <Button
                                variant="contained"
                                fullWidth
                                type="submit"
                                sx={{
                                  height: { xs: "36px", sm: "32px" },
                                  flex: { xs: "1 1 auto", sm: "0 0 auto" },
                                  minWidth: { xs: "100%", sm: "100px" },
                                  maxWidth: { sm: "150px" },
                                  backgroundColor: "#00bcd4",
                                  textTransform: "none",
                                  fontSize: "0.75rem",
                                  "&:hover": {
                                    backgroundColor: "#008c9e",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </Box>
                          </Box>
                        </div>
                      </div>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div
                className="table-ad__wrapper"
                onContextMenu={handleContextMenu}
              >
                <div className="table-ad__wrapperCard">
                  <MaterialReactTable table={table} />

                  {/* Context Menu */}
                  <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                    }
                  >
                    {/* <MenuItem onClick={handlePaste}>Paste</MenuItem> */}
                    <MenuItem onClick={handleResizing}>
                      {showRowResizing ? "Disable Resizing" : "enable Resizing"}
                    </MenuItem>
                  </Menu>
                </div>
                {/* <FileUpload
                  open={openFileUpload}
                  onFileUploadClose={handleFileUploadClose}
                  onFileUploadSubmit={handleFileUploadSubmit}
                  acceptedFileTypes=".csv,.json"
                /> */}
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)
function useGetData(
  filterModes: { mode: string; id: string; value: unknown }[],
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: any,
  sorting: any
) {
  return useQuery<{ results: User[]; totalCount: number }>({
    // ✅ Correct return type
    queryKey: ["users", filterModes, pagination, sorting], // Ensure proper re-fetching
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/counterparty-companies/?page=${
        pagination.pageIndex + 1
      }&page_size=${pagination.pageSize}`;

      if (filterModes.length > 0) {
        console.log("filterModes---,", filterModes);
        const queryParams = filterModes
          .map(
            (e) =>
              `fieldName__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${
                e.id
              }=${String(e.value)}__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${
                e.mode
              }`
          )
          .join("&");

        url += `&${queryParams}`;
      }
      console.log("sortparams:", sorting);
      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc}_sorting`;
        url += `&${sortParams}`;

        console.log("yesss");
      } else {
        console.log("sortParams");
      }

      const response = await axiosInstance.get(url);
      console.log("response", response.data);
      setTotalCount(response.data.count);
      return {
        results: response.data.results as User[],
        totalCount: response.data.count as number,
      };
    },
    refetchOnWindowFocus: false,
  });
}

function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (user: User) => {
      console.group("🔄 User Update Mutation");
      console.log("Input User Object:", user);

      if (!user || !user.id) {
        console.error("❌ Invalid user object:", user);
        throw new Error("User object is invalid or missing ID");
      }

      // Prepare payload
      const payload = {
        ...user,
        remarks: user.remarks || "", // Send empty string instead of null
        im_buffer_factor:
          user.im_buffer_factor === "" || user.im_buffer_factor == null
            ? null
            : user.im_buffer_factor,
      };

      console.log("📦 Prepared Payload:", payload);

      try {
        const { data } = await axiosInstance.put(
          `${backendbaseUrl}/paper-app/counterparty-companies/${payload.id}/`,
          payload
        );
        console.log("✅ API Response:", data);
        console.groupEnd();
        return data;
      } catch (error) {
        console.error("❌ API Request Failed:", error);
        console.groupEnd();
        throw error;
      }
    },

    onMutate: async (newUserInfo: User) => {
      console.log("🔮 Optimistic Update - New User Info:", newUserInfo);
      await queryClient.cancelQueries({ queryKey: ["users"] });
      const previousUsers = queryClient.getQueryData(["users"]);
      queryClient.setQueryData(["users"], (oldData: any) => {
        if (Array.isArray(oldData?.results)) {
          return {
            ...oldData,
            results: oldData.results.map((prevUser: User) =>
              prevUser.id === newUserInfo.id ? newUserInfo : prevUser
            ),
          };
        }
        return oldData;
      });
      return { previousUsers };
    },

    onError: (err, newUser, context) => {
      console.error("❌ Update Failed:", err);
      queryClient.setQueryData(["users"], context?.previousUsers);
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      //send api update request here
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      try {
        await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/counterparty-companies/${userId}/`
        );
        console.log("userId", userId);
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }

      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });

      const previousUsers = queryClient.getQueryData(["users"]);

      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );

      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("❌ Delete Failed:", err);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }), //refetch users after mutation, disabled for demo
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // CounterpartyName: !validateRequired(user.name)
    //   ? "First Name is Required"
    //   : "",
    // name: !validateRequired(user.name) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
